<div class="dir-config-page">

  <!-- Header -->
  <div class="dir-header">
    <div class="dir-title">
      <i class="material-icons">contacts</i>
      <div>
        <h5>Directory Visibility</h5>
        <span class="dir-sub">Control which extension pools each role can see and dial in the console directory</span>
      </div>
    </div>
  </div>

  <!-- Load error -->
  <div *ngIf="loadError" class="dir-error-banner">
    <i class="material-icons">error_outline</i> {{ loadError }}
  </div>

  <!-- Loading -->
  <div *ngIf="loading" class="dir-loading">
    <i class="material-icons spin">sync</i> Loading configuration…
  </div>

  <!-- Matrix -->
  <div *ngIf="!loading && !loadError" class="dir-card">

    <div class="dir-table-wrap">
      <table class="dir-table">
        <thead>
          <tr>
            <th class="th-role">Role</th>
            <th *ngFor="let pool of allPools" class="th-pool">
              <span class="pool-label">{{ pool.label }}</span>
            </th>
            <th class="th-action"></th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let row of rows" class="dir-row">
            <td class="td-role">
              <span class="role-badge">{{ row.viewerLabel }}</span>
            </td>
            <td *ngFor="let pool of row.pools" class="td-check">
              <label class="check-wrap">
                <input type="checkbox" [(ngModel)]="pool.checked" />
                <span class="checkmark"></span>
              </label>
            </td>
            <td class="td-action">
              <div class="row-actions">
                <button class="save-btn"
                        [class.saving]="row.saving"
                        [class.saved]="row.saved"
                        [disabled]="row.saving"
                        (click)="save(row)">
                  <i class="material-icons">{{ row.saved ? 'check' : row.saving ? 'sync' : 'save' }}</i>
                  {{ row.saved ? 'Saved' : row.saving ? 'Saving…' : 'Save' }}
                </button>
                <span *ngIf="row.error" class="row-error">{{ row.error }}</span>
              </div>
            </td>
          </tr>
        </tbody>
      </table>
    </div>

    <div class="dir-hint">
      <i class="material-icons">info_outline</i>
      Changes take effect immediately — agents will see the updated directory on their next page load or console refresh.
    </div>
  </div>

</div>
